module.exports = {
	extends: [
		'/',
		'templates',
		'globals',
		'newsletter',
		'entity',
		'controller'
	],

	config: {
		usage: 'management',
		entityContext: 'mailing'
	}
}